<vectronic-history
  class="device-history"
  [items]="historyItems()"
  [types]="types"
  [(selectedType)]="selectedType"
  [canModifyComments]="canModifyComments()"
  [title]="title()"
  allType="all"
  [showAddComment]="false"
  (itemAction)="onHistoryItemAction($event)"
/>
